import { Button, ButtonProps } from 'src/UIKit';
import React, { FC, useCallback } from 'react';
import { useSpamContactDialogController } from '../../controllers/SpamContactDialogController';
import { SpamContactDialogParams } from '../../types';


const useSpamContactDialog = () => {
  const { handleContactMarkAsSpam, SpamContactDialog } = useSpamContactDialogController();

  const SpamButton: FC<SpamContactDialogParams & ButtonProps> = useCallback(
    props => {
      const { selectedCompanyId, contactId, isSpam, nextAction, fullWidth, ...buttonProps } = props;
      return (
        <Button
          variant="outlined"
          size="medium"
          fullWidth={fullWidth}
          onClick={() =>
            handleContactMarkAsSpam({ selectedCompanyId, contactId, isSpam, nextAction })
          }
          {...buttonProps}
        >
          {isSpam ? 'Not Spam' : 'Mark as Spam'}
        </Button>
      );
    },
    [handleContactMarkAsSpam],
  );

  return {
    handleContactMarkAsSpam,
    SpamButton,
    SpamContactDialog,
  };
};

export default useSpamContactDialog;
